import { NovaChatContainer, NovaProvider } from '@newfront-insurance/nova-core/v2';
import { useProvider } from '@newfront-insurance/react-provision';
import type { JSX } from 'react';

import { AuthProvider } from '@/client/providers/auth';

export function NovaChatFeature(): JSX.Element | null {
  const { userDetails } = useProvider(AuthProvider);
  const { uuid: userUuid, scopes } = userDetails ?? {};

  if (!userUuid) {
    return null;
  }

  return (
    <NovaProvider userUuid={userUuid} scopes={scopes} authProvider={AuthProvider} isStandaloneMode>
      <NovaChatContainer />
    </NovaProvider>
  );
}
